import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  /**
   * Value to display.
   */
  value: ZephyrWeb.AddressInfo;
  /**
   * If `true`, the address will be formatted as a single line.
   */
  singleLine?: boolean;
}


declare module 'vue/types/vue' {
  export interface Vue {
    DisplayAddress: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'DisplayAddress' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: null,
    singleLine: { type: Boolean }
  },
  setup(__props: any) {

/**
 * `DisplayAddress` component properties.
 */


return { __sfc: true, }
}

})